import { defineMessages } from 'react-intl';

export const REJECT_LINKS_FIELD = 'reject_links';

// Exportado para uso na validação do formulário (customizations não são extraídas pelo i18n).
export const rejectLinksMessages = defineMessages({
  field_reject_links: {
    id: 'form_field_reject_links',
    defaultMessage: 'Reject texts with links?',
  },
  field_reject_links_description: {
    id: 'form_field_reject_links_description',
    defaultMessage:
      'When enabled, the submission is blocked if the field contains a URL.',
  },
  field_reject_links_error: {
    id: 'form_field_reject_links_error',
    defaultMessage: 'This field does not accept links.',
  },
});

export const getRejectLinksProperty = (intl) => ({
  title: intl.formatMessage(rejectLinksMessages.field_reject_links),
  description: intl.formatMessage(
    rejectLinksMessages.field_reject_links_description,
  ),
  type: 'boolean',
  default: false,
});

// Detecta esquemas (http, ftp, mailto), prefixo "www." e domínios com TLD conhecido.
const LINK_REGEX =
  /(?:[a-z][a-z0-9+.-]*:\/\/|www\.|mailto:)\S+|[\w-]+\.(?:com|net|org|edu|gov|mil|int|info|biz|io|co|br|pt|us|uk|me|tv|app|dev|xyz|online|site|link|click|shop|store)(?:\.[a-z]{2})?(?:[/?#]\S*)?/i;

export const containsLink = (value) =>
  typeof value === 'string' && LINK_REGEX.test(value);
